import {useEffect, useState} from "react";
import {exibirMensagemErro, exibirMensagemSucesso, xfetch, HttpVerbo} from "../../util";
import {PaginaLogada} from "../layout";
import {Button, Card, Grid, TextInput, Title} from "@mantine/core";
import {COL_RESP_2, COL_RESP_4} from "../../config/constantes/constantes-mantine";
import {BotaoSalvar} from "../botao/botao-mantine";
import {useForm} from "@mantine/form";

interface CadastrarNomeProps {
  label: string;
  labelListagem: string;
  url: string;
  urlAlterar?: string;
}

interface dadosCadastroNome {
  nome: string;
  id: number;
}

export default function CadastrarNome(props: Readonly<CadastrarNomeProps>) {

  const [isCarregando, setIsCarregando] = useState(false)
  const [lista, setLista] = useState<dadosCadastroNome[]>([])

  const form = useForm({
    initialValues: {
      nome: "",
    },
    validate: {
      nome: (value) => (value.length <= 4 ? "Nome muito curto" : null),
    },
  });

  function carregarListagem() {
    setIsCarregando(true)
    xfetch(props.url, {}, HttpVerbo.GET)
      .then(res => res.json())
      .then((dados: dadosCadastroNome[]) => {
        setLista(dados.sort((a: any, b: any) => a.nome.localeCompare(b.nome)))
        setIsCarregando(false)
      })
      .catch(e => setIsCarregando(false))

  }

  useEffect(() => {
    carregarListagem()
  }, [])

  function enviar() {
    setIsCarregando(true)
    xfetch(props.url, {nome: form.values.nome}, HttpVerbo.POST)
      .then(res => {
        if (res.status == 201) {
          exibirMensagemSucesso(props.label + ' cadastrado com sucesso');
          form.reset()
          carregarListagem()
        }
      })
      .catch((e) => exibirMensagemErro('Erro ao cadastrar ' + props.label + '\n ' + e.label))
      .finally(() => setIsCarregando(false))

  }

  return (
    <PaginaLogada titulo={"Nova " + props.label} isCarregando={isCarregando}>
        <Card withBorder shadow="sm" radius="md">
          <form onSubmit={form.onSubmit(enviar)}>
          <Grid>
            <Grid.Col span={COL_RESP_4}>
              <TextInput
                required
                autoComplete={"off"}
                label={props.label}
                placeholder={props.label}
                {...form.getInputProps('nome')}
                onChange={(e) => form.setFieldValue("nome", e.currentTarget.value)}
                />
            </Grid.Col>
            <Grid.Col span={COL_RESP_2} style={{alignSelf: 'flex-end'}}>
              <BotaoSalvar type={"submit"} />
            </Grid.Col>
          </Grid>
          </form>
        </Card>
        <Card withBorder shadow="sm" radius="md" mt={50}>
          <Card.Section withBorder>
            <Title order={4} p={"md"}>{props.labelListagem}</Title>
          </Card.Section>
          <Card.Section>
            <>
              {lista.map((v, k) => {
                if (props.urlAlterar) {
                  return (
                      <Button key={k} component={"a"} variant={"default"}  m={10} href={`${props.urlAlterar}/${v.id}`}>
                          {v.nome}
                      </Button>
                  )
                }
                return (<Button key={k} variant={"transparent"} color={"dark.5"} m={10}> {v.nome} </Button>)
              })}
              </>
          </Card.Section>
        </Card>
    </PaginaLogada>

  );
}
